import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ProgramsReportsSideMenuComponent } from './programs-reports-side-menu/programs-reports-side-menu.component';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-programs-report',
  imports: [TranslateModule, RouterOutlet, ProgramsReportsSideMenuComponent],
  templateUrl: './programs-report.component.html',
  styleUrl: './programs-report.component.scss',
})
export class ProgramsReportComponent {}
